module.exports = __webpack_public_path__ + "static/media/assignExpert.b54557e7.svg";